export function Billboards(
  state = {
    data: {},
    isLoading: false,
  },
  { action, types },
) {
  if (!types) return state;
  switch (action.type) {
  case types.getBillboards:
    return { ...state, data: action.result.state, isLoading: false };
  case types.getBillboardsRequest:
    return { ...state, isLoading: true };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/billboards/data/reducers.js